import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-trim-selector"
}
const _hoisted_2 = {
  key: 0,
  class: "c-trim-selector__inner"
}
const _hoisted_3 = { class: "c-trim-selector__item" }
const _hoisted_4 = { class: "o-select__wrap" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "c-trim-selector__item -half" }
const _hoisted_7 = { class: "o-select__wrap -ico -cabine" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "c-trim-selector__item -half" }
const _hoisted_10 = { class: "o-select__wrap -ico -caisse" }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "c-trim-selector__item"
}
const _hoisted_13 = { class: "o-select__wrap -ico -moteur" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "c-trim-selector__item -half" }
const _hoisted_16 = { class: "o-select__wrap -ico -roue" }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 1,
  class: "c-trim-selector__item -half"
}
const _hoisted_19 = { class: "o-select__wrap -ico -traction" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "c-trim-selector__item" }
const _hoisted_23 = { class: "o-select__wrap" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "c-trim-selector__item" }
const _hoisted_26 = {
  key: 0,
  class: "o-select__wrap"
}
const _hoisted_27 = ["value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($data.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.$root.pickup == '1')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("select", {
                    class: "o-select o-select-simple",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.trimName) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.trimNames, (name, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: name
                      }, _toDisplayString(name), 9 /* TEXT, PROPS */, _hoisted_5))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $data.trimName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("select", {
                    class: "o-select o-select-simple",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.cabine) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.cabines, (name, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: name
                      }, _toDisplayString(name), 9 /* TEXT, PROPS */, _hoisted_8))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $data.cabine]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("select", {
                    class: "o-select o-select-simple",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.caisse) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.caisses, (name, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: name
                      }, _toDisplayString(name), 9 /* TEXT, PROPS */, _hoisted_11))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $data.caisse]
                  ])
                ])
              ]),
              ($options.moteurs.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("select", {
                        class: "o-select o-select-simple",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.moteur) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.moteurs, (name, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: index,
                            value: name
                          }, _toDisplayString(name), 9 /* TEXT, PROPS */, _hoisted_14))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */), [
                        [_vModelSelect, $data.moteur]
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("select", {
                    class: "o-select o-select-simple",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.roue) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.roues, (name, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: name
                      }, _toDisplayString(name), 9 /* TEXT, PROPS */, _hoisted_17))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $data.roue]
                  ])
                ])
              ]),
              ($options.tractions.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("select", {
                        class: "o-select o-select-simple",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (( $data.traction) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tractions, (name, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: index,
                            value: name
                          }, _toDisplayString(name), 9 /* TEXT, PROPS */, _hoisted_20))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */), [
                        [_vModelSelect,  $data.traction]
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("select", {
                    class: "o-select o-select-simple",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.trimIndex) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.trims, (trim, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: index
                      }, _toDisplayString(trim.name), 9 /* TEXT, PROPS */, _hoisted_24))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $data.trimIndex]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                ($options.currentTrim.options)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("select", {
                        class: "o-select o-select-simple",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.optionIndex) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.currentTrim.options, (option, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: index,
                            value: index
                          }, _toDisplayString(option.name), 9 /* TEXT, PROPS */, _hoisted_27))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */), [
                        [_vModelSelect, $data.optionIndex]
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
      ]))
    : _createCommentVNode("v-if", true)
}